import { render, staticRenderFns } from "./pages6.vue?vue&type=template&id=c30fbf20&"
import script from "./pages6.vue?vue&type=script&lang=js&"
export * from "./pages6.vue?vue&type=script&lang=js&"
import style0 from "./pages6.vue?vue&type=style&index=0&id=c30fbf20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports